<template>
  <div class="grid-box">
    <!-- 投标模块 -->
    <div v-for="(paItem,i) in menuData" :key="i" class="items-box">
      <!-- 模块名称 -->
      <div class="grid-title" v-html="paItem.menu_name"></div>
      <!-- 模块名称结束 -->
      <!-- 头标展示区 -->
      <van-grid square :column-num="4" icon-size="1rem">
        <van-grid-item
          v-for="(item,index) in paItem.list"
          :key="nugIndex(index)"
          :icon="item.file_url"
          :text="item.menu_name"
          :class="isClass(item)"
          :badge="item.ashFlag ==1?'':item.ashFlag ==0?'+':'-'"
          @click="item.ashFlag ==1?'':item.ashFlag ==0?addItems(item):delItems(item)"
        />
      </van-grid>
      <!-- 头标展示区结束 -->
    </div>
    <!-- 投标模块结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    menuList: {
      type: Array
    },
    stusConfig: {
      type: Object
    }
  },
  watch: {
    menuList(val) {
      this.menuData = val; //给展示的list赋值
    }
  },
  data() {
    return {
      menuData: [], //接收父组件传递过来的menu数据
      currentLoginInfo: {} //登录人信息
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    // 判断选项添加class ，权限不可操作
    isClass(item) {
      if (this.stusConfig[item.menu_code]) {
        let flagStatus =
          this.stusConfig[item.menu_code].visible.indexOf(
            this.currentLoginInfo
          ) == -1;
        if (flagStatus) {
          item.ashFlag = 1;
        }
      }
      return [
        { ashIcons: item.ashFlag == 1 },
        item.ashFlag == 0 ? "van-info-red" : "van-info-yellow"
      ];
    },
    // 添加常用服务
    addItems(item) {
      this.$emit("addItem", item);
    },
    // 删除常用服务
    delItems(item) {
      this.$emit("delItem", item);
    },
    // 防止动态样式加不上，所有给:key加个随机数
    nugIndex(index) {
      return index + Math.round(Math.random() * 100000);
    },
    // 初始化函数
    init() {
      this.gianListData();
      const loginInfo = localStorage.getItem("loginInfo");
      this.currentLoginInfo = loginInfo ? JSON.parse(loginInfo).identity : {};
    },
    // 给展示的list赋值
    gianListData() {
      this.menuData = this.menuList;
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/index.styl';
@import '../../../assets/stylus/reset.css';

.drog-move {
  transition: transform 1s;
}

>>>.name-text {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #B2B2B2;
  line-height: 18px;
  display: inline-block;
  margin-left: 10px;
}

>>>.ashIcons {
  img, span {
    opacity: 0.3;
  }
}

>>>.van-info-red {
  .van-info {
    background: #29BEBC;
  }
}

>>>.van-info-yellow {
  .van-info {
    background: #F9564B;
  }
}

.grid-box {
  .items-box {
    background: #fff;
    margin-bottom: 10px;
    padding-top: 10px;
  }

  .grid-title {
    color: #353535;
    font-size: 17px;
    padding: 0px 15px 10px;
    font-size: 17px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 24px;
  }

  .border {
    margin-bottom: 10px;

    div {
      border: 2px dashed #e5e5e5;
      width: 66%;
      margin: auto;
    }
  }
}
</style>